import logo from './comuneVicinoLogo.svg';
import coloredLogo from './comuneVicinoLogoColor.svg';

export const settings = {
    "title": "Comune Vicino",
    "apiUrl": "https://api.comunevicino.it/api",
    "storageUrl": "https://api.comunevicino.it/",
    "tinyKey": "u2y9r6cw0e1erg33drzg4fs0swwi1zrs85bcin3ynrsxlwz2",
    "googleMapKey": "AIzaSyAxkgZt7tuPJoe6BdWt_CBq98qczqJ6Jmc", 
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "locale": {
        "currency": 'EUR',
        "country": 'it-IT'
    },
    "logo": logo,
    "supportLink" : "https://www.comunevicino.it",
    "debug": true
}
